module.exports = __webpack_public_path__ + "img/lunas_glasses.53232541.jpg";